export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'romance', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'action', name: '动作', slug: 'action', icon: 'ri-sword-line' },
  { id: 'suspense', name: '悬疑', slug: 'suspense', icon: 'ri-search-eye-line' },
  { id: 'comedy', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'drama', name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { id: 'horror', name: '惊悚', slug: 'horror', icon: 'ri-ghost-line' },
];